import { render, staticRenderFns } from "./getting-started.vue?vue&type=template&id=1944803d&scoped=true&lang=html&"
import script from "./getting-started.vue?vue&type=script&lang=js&"
export * from "./getting-started.vue?vue&type=script&lang=js&"
import style0 from "./getting-started.vue?vue&type=style&index=0&id=1944803d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944803d",
  null
  
)

component.options.__file = "getting-started.vue"
export default component.exports